<div class="dialog">
  <header class="dialog__header">
    <ci-icon 
      class="dialog__icon"
      [class.success]="iconName() === 'success'"
      [class.warning]="iconName() === 'warning'"
      [class.error]="iconName() === 'error'"
      type="svg" 
      [name]="iconName()"
      scale="1.5x"
    ></ci-icon>
      
    <h2 
      [innerHTML]="getTitleString() | translate"
      class="dialog__title ci-subheading-semibold"
      [class.no-icon]="!iconName()"
    ></h2>
  </header>
 
  @if (getContentString()) {
    <main class="dialog__main">
      <p 
        [innerHTML]="getContentString() | translate"
        class="main__text ci-paragraph-p1-regular"
      ></p>
    </main>
  }
  
  @if (data.handleClickPrimaryButton || data.handleClickSecondaryButton) {
    <footer class="dialog__footer">
      @if (data.secondaryActionButtonText) {
        <ci-text-button 
          class="dialog__secondary-text-button"
          class-name="ci-text-btn-primary-s" 
          type="button" 
          [attr.aria-label]="data.secondaryActionButtonText | translate"
          (click)="data.handleClickSecondaryButton()"
        >
          {{ data.secondaryActionButtonText | translate }}
        </ci-text-button>
      }
        
      @if (data.handleClickPrimaryButton) {
        <ci-text-button 
          class="dialog__primary-text-button"
          class-name="ci-text-btn-primary-s" 
          type="button" 
          [attr.aria-label]="data.primaryActionButtonText | translate"
          (click)="data.handleClickPrimaryButton()"
        >
          {{ data.primaryActionButtonText| translate }}
        </ci-text-button>
      }
    </footer>
  }
</div>